var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmallCaret = function SvgSmallCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C7D0",
    fillRule: "evenodd",
    d: "M7.634 6.282 1.918.678a.7.7 0 0 0-.496-.2.7.7 0 0 0-.497.2l-.421.413a.68.68 0 0 0 0 .974l4.8 4.706-4.806 4.71a.68.68 0 0 0 0 .975l.421.413c.133.13.31.2.497.2a.7.7 0 0 0 .497-.2l5.721-5.61a.68.68 0 0 0 .205-.488.68.68 0 0 0-.205-.489",
    clipRule: "evenodd"
  })));
};
export default SvgSmallCaret;